import { fromJS } from 'immutable';
import { basicSort } from '../../../../util/sortUtils';
import { sort } from '../../event/related-runup/runupReduxConstants';

export const RUNUP_SEARCH_REQUEST = 'RUNUP_SEARCH_REQUEST';
export const RUNUP_SEARCH_SUCCESS = 'RUNUP_SEARCH_SUCCESS';
export const RUNUP_SEARCH_FAILURE = 'RUNUP_SEARCH_FAILURE';

export const RUNUP_SEARCH_CLEAR = 'RUNUP_SEARCH_CLEAR';
export const RUNUP_SEARCH_CLEAR_REDIRECT = 'RUNUP_SEARCH_CLEAR_REDIRECT';

export const RUNUP_SEARCH_REGION_REQUEST = 'RUNUP_SEARCH_REGION_REQUEST';
export const RUNUP_SEARCH_REGION_SUCCESS = 'RUNUP_SEARCH_REGION_SUCCESS';
export const RUNUP_SEARCH_REGION_FAILURE = 'RUNUP_SEARCH_REGION_FAILURE';

export const RUNUP_SEARCH_COUNTRY_REQUEST = 'RUNUP_SEARCH_COUNTRY_REQUEST';
export const RUNUP_SEARCH_COUNTRY_SUCCESS = 'RUNUP_SEARCH_COUNTRY_SUCCESS';
export const RUNUP_SEARCH_COUNTRY_FAILURE = 'RUNUP_SEARCH_COUNTRY_FAILURE';

export const RUNUP_SEARCH_AREA_REQUEST = 'RUNUP_SEARCH_AREA_REQUEST';
export const RUNUP_SEARCH_AREA_SUCCESS = 'RUNUP_SEARCH_AREA_SUCCESS';
export const RUNUP_SEARCH_AREA_FAILURE = 'RUNUP_SEARCH_AREA_FAILURE';

export const RUNUP_SEARCH_RUNUP_REGION_REQUEST = 'RUNUP_SEARCH_RUNUP_REGION_REQUEST';
export const RUNUP_SEARCH_RUNUP_REGION_SUCCESS = 'RUNUP_SEARCH_RUNUP_REGION_SUCCESS';
export const RUNUP_SEARCH_RUNUP_REGION_FAILURE = 'RUNUP_SEARCH_RUNUP_REGION_FAILURE';

export const RUNUP_SEARCH_RUNUP_COUNTRY_REQUEST = 'RUNUP_SEARCH_RUNUP_COUNTRY_REQUEST';
export const RUNUP_SEARCH_RUNUP_COUNTRY_SUCCESS = 'RUNUP_SEARCH_RUNUP_COUNTRY_SUCCESS';
export const RUNUP_SEARCH_RUNUP_COUNTRY_FAILURE = 'RUNUP_SEARCH_RUNUP_COUNTRY_FAILURE';

export const RUNUP_SEARCH_RUNUP_AREA_REQUEST = 'RUNUP_SEARCH_RUNUP_AREA_REQUEST';
export const RUNUP_SEARCH_RUNUP_AREA_SUCCESS = 'RUNUP_SEARCH_RUNUP_AREA_SUCCESS';
export const RUNUP_SEARCH_RUNUP_AREA_FAILURE = 'RUNUP_SEARCH_RUNUP_AREA_FAILURE';

export const RUNUP_SEARCH_RUNUP_MEASURE_TYPE_REQUEST = 'RUNUP_SEARCH_RUNUP_MEASURE_TYPE_REQUEST';
export const RUNUP_SEARCH_RUNUP_MEASURE_TYPE_SUCCESS = 'RUNUP_SEARCH_RUNUP_MEASURE_TYPE_SUCCESS';
export const RUNUP_SEARCH_RUNUP_MEASURE_TYPE_FAILURE = 'RUNUP_SEARCH_RUNUP_MEASURE_TYPE_FAILURE';

export const RUNUP_SEARCH_VALIDITY_REQUEST = 'RUNUP_SEARCH_VALIDITY_REQUEST';
export const RUNUP_SEARCH_VALIDITY_SUCCESS = 'RUNUP_SEARCH_VALIDITY_SUCCESS';
export const RUNUP_SEARCH_VALIDITY_FAILURE = 'RUNUP_SEARCH_VALIDITY_FAILURE';

export const RUNUP_SEARCH_CAUSE_REQUEST = 'RUNUP_SEARCH_CAUSE_REQUEST';
export const RUNUP_SEARCH_CAUSE_SUCCESS = 'RUNUP_SEARCH_CAUSE_SUCCESS';
export const RUNUP_SEARCH_CAUSE_FAILURE = 'RUNUP_SEARCH_CAUSE_FAILURE';

export const RUNUP_DATA_SORT = 'RUNUP_DATA_SORT';


const initialState = fromJS({
  searching: false,
  fetched: false,
  runups: [],
  queryParameters: {},
  searchRedirect: false,

  fetchedRegions: false,
  regions: [],
  fetchedCountries: false,
  countries: [],
  fetchingAreas: false,
  areas: [],

  fetchedRunupRegions: false,
  runupRegions: [],
  fetchedRunupCountries: false,
  runupCountries: [],
  fetchingRunupAreas: false,
  runupAreas: [],
  fetchedRunupMeasurementTypes: false,
  runupMeasurementTypes: [],
  fetchedValidities: false,
  validities: [],
  fetchedCauses: false,
  causes: [],

  sort,
});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const runupSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case RUNUP_SEARCH_CLEAR_REDIRECT:
      return state.set('searchRedirect', false);
    case RUNUP_SEARCH_CLEAR:
      return initialState.merge(fromJS({
        sort: state.get('sort'),
      }));
    case RUNUP_DATA_SORT:
      return state.merge(fromJS({
        runups: basicSort(action.sort, state.get('runups')),
        sort: action.sort,
      }));

    case RUNUP_SEARCH_REQUEST:
      return state.merge(fromJS({
        searching: true,
        fetched: false,
        queryParameters: action.queryParameters,
        searchRedirect: Boolean(action.searchRedirect),
      }));
    case RUNUP_SEARCH_SUCCESS:
      return state.merge(fromJS({
        searching: false,
        fetched: true,
        runups: basicSort(state.get('sort'), fromJS(action.response.items)),
      }));
    case RUNUP_SEARCH_FAILURE:
      return state.merge(fromJS({
        searching: false,
        fetched: true,
      }));

    case RUNUP_SEARCH_REGION_REQUEST:
      return state.merge(fromJS({
        fetchedRegions: false,
      }));
    case RUNUP_SEARCH_REGION_SUCCESS:
      return state.merge(fromJS({
        fetchedRegions: true,
        regions: action.response.items,
      }));
    case RUNUP_SEARCH_REGION_FAILURE:
      return state.merge(fromJS({
        fetchedRegions: true,
      }));

    case RUNUP_SEARCH_COUNTRY_REQUEST:
      return state.merge(fromJS({
        fetchedCountries: false,
      }));
    case RUNUP_SEARCH_COUNTRY_SUCCESS:
      return state.merge(fromJS({
        fetchedCountries: true,
        countries: action.response.items,
      }));
    case RUNUP_SEARCH_COUNTRY_FAILURE:
      return state.merge(fromJS({
        fetchedCountries: true,
      }));

    case RUNUP_SEARCH_AREA_REQUEST:
      return state.merge(fromJS({
        fetchingAreas: true,
      }));
    case RUNUP_SEARCH_AREA_SUCCESS:
      return state.merge(fromJS({
        fetchingAreas: false,
        areas: action.response.items,
      }));
    case RUNUP_SEARCH_AREA_FAILURE:
      return state.merge(fromJS({
        fetchingAreas: false,
        areas: initialState.get('areas'),
      }));

    case RUNUP_SEARCH_RUNUP_REGION_REQUEST:
      return state.merge(fromJS({
        fetchedRunupRegions: false,
      }));
    case RUNUP_SEARCH_RUNUP_REGION_SUCCESS:
      return state.merge(fromJS({
        fetchedRunupRegions: true,
        runupRegions: action.response.items,
      }));
    case RUNUP_SEARCH_RUNUP_REGION_FAILURE:
      return state.merge(fromJS({
        fetchedRunupRegions: true,
      }));

    case RUNUP_SEARCH_RUNUP_COUNTRY_REQUEST:
      return state.merge(fromJS({
        fetchedRunupCountries: false,
      }));
    case RUNUP_SEARCH_RUNUP_COUNTRY_SUCCESS:
      return state.merge(fromJS({
        fetchedRunupCountries: true,
        runupCountries: action.response.items,
      }));
    case RUNUP_SEARCH_RUNUP_COUNTRY_FAILURE:
      return state.merge(fromJS({
        fetchedRunupCountries: true,
      }));

    case RUNUP_SEARCH_RUNUP_AREA_REQUEST:
      return state.merge(fromJS({
        fetchingRunupAreas: true,
      }));
    case RUNUP_SEARCH_RUNUP_AREA_SUCCESS:
      return state.merge(fromJS({
        fetchingRunupAreas: false,
        runupAreas: action.response.items,
      }));
    case RUNUP_SEARCH_RUNUP_AREA_FAILURE:
      return state.merge(fromJS({
        fetchingRunupAreas: false,
        runupAreas: initialState.get('runupAreas'),
      }));

    case RUNUP_SEARCH_RUNUP_MEASURE_TYPE_REQUEST:
      return state.merge(fromJS({
        fetchedRunupMeasurementTypes: false,
      }));
    case RUNUP_SEARCH_RUNUP_MEASURE_TYPE_SUCCESS:
      return state.merge(fromJS({
        fetchedRunupMeasurementTypes: true,
        runupMeasurementTypes: action.response.items,
      }));
    case RUNUP_SEARCH_RUNUP_MEASURE_TYPE_FAILURE:
      return state.merge(fromJS({
        fetchedRunupMeasurementTypes: true,
      }));

    case RUNUP_SEARCH_VALIDITY_REQUEST:
      return state.merge(fromJS({
        fetchedValidities: false,
      }));
    case RUNUP_SEARCH_VALIDITY_SUCCESS:
      return state.merge(fromJS({
        fetchedValidities: true,
        validities: action.response.items,
      }));
    case RUNUP_SEARCH_VALIDITY_FAILURE:
      return state.merge(fromJS({
        fetchedValidities: true,
      }));

    case RUNUP_SEARCH_CAUSE_REQUEST:
      return state.merge(fromJS({
        fetchedCauses: false,
      }));
    case RUNUP_SEARCH_CAUSE_SUCCESS:
      return state.merge(fromJS({
        fetchedCauses: true,
        causes: action.response.items,
      }));
    case RUNUP_SEARCH_CAUSE_FAILURE:
      return state.merge(fromJS({
        fetchedCauses: true,
      }));

    default:
      return state;
  }
};
